module.exports = __webpack_public_path__ + "img/cate-icon-10.db0e683c.png";